import { Auth } from 'aws-amplify';
import Axios from 'axios';
import { useAuthStore } from '@stores/auth';

const baseURL = process.env.REACT_APP_API_BASEURL;
const api = Axios.create({ baseURL });

api.interceptors.request.use(async (config) => {
  // const isTokenExpired = UserStore.authTokenData.exp < Math.floor(Date.now() / 1000);
  const authData = useAuthStore.getState().authData;
  const isTokenExpired = authData?.exp < Math.floor(Date.now() / 1000);

  if (isTokenExpired) {
    await Auth.currentAuthenticatedUser();
    const currentSession = await Auth.currentSession();
    const getIdToken = currentSession.getIdToken();
    useAuthStore.setState({ authData: getIdToken.payload, idToken: getIdToken.getJwtToken() });

    api.defaults.headers.common['Authorization'] = `Bearer ${getIdToken.getJwtToken()}`;
    // eslint-disable-next-line
    // @ts-ignore
    config.headers.common['Authorization'] = `Bearer ${getIdToken.getJwtToken()}`;
  }

  return config;
});

export default api;
